/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './data';
import '../billing/data';
import '../common/time';
import './common';
import '../common/currency';
import '../precog/v2/common';
import './assets';
import '../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "service": {
            "nested": {
              "UsageActionType": {
                "values": {
                  "NONE": 0,
                  "AGGREGATED": 1,
                  "DISCRETE": 2
                }
              },
              "UsageMode": {
                "values": {
                  "INCREMENT": 0,
                  "DECREMENT": 1,
                  "SET": 2
                }
              },
              "DiscreteUsageSettings": {
                "fields": {
                  "usageMode": {
                    "type": ".squareup.sub2.service.UsageMode",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "INCREMENT"
                    }
                  }
                }
              },
              "CreateOrUpdateSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "customPricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "startInFreeTrialNoObligationState": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "customFreeTrialDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 11,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 12,
                    "rule": "optional"
                  },
                  "activationSource": {
                    "type": ".squareup.sub2.data.ActivationSource",
                    "id": 13,
                    "rule": "optional"
                  },
                  "expireAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "CreateOrUpdateSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateSquareOneSubscriptionForOnboardedMerchantRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "assignSquarePlan": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "activationSource": {
                    "type": ".squareup.sub2.data.ActivationSource",
                    "id": 5,
                    "rule": "optional"
                  },
                  "avt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "assignedVariant": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "CreateSquareOneSubscriptionForOnboardedMerchantResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriptionStatus": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "customPricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 9,
                    "rule": "optional"
                  },
                  "customFreeTrialDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 10,
                    "rule": "optional"
                  },
                  "expireAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "CreateSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ActivatePresaleSubscriptionsRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "ActivatePresaleSubscriptionsResponse": {
                "fields": {
                  "subscriptions": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UpdatePresaleSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "UpdatePresaleSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateSubscriptionRequest": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cancelFutureDowngrade": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "startInFreeTrialNoObligationState": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "UpdateSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CancelSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cancelImmediately": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "feedback": {
                    "type": ".squareup.sub2.data.Feedback",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2
                  },
                  "subscriptionKey": {
                    "type": ".squareup.sub2.data.SubscriptionKey",
                    "id": 8
                  }
                },
                "nested": {
                  "subscription_descriptor": {
                    "oneof": ["subscriptionToken", "subscriptionKey"]
                  }
                }
              },
              "CancelSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "PauseSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "resumeAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pauseImmediately": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "resumeAtDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "PauseSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ResumeSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ResumeSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "IsSubscribedToFeatureRequest": {
                "fields": {
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "IsSubscribedToFeatureResponse": {
                "fields": {
                  "isSubscribed": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriptionStatus": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ListSubscribedFeaturesRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListSubscribedFeaturesResponse": {
                "fields": {
                  "subscribedFeatures": {
                    "type": ".squareup.sub2.data.SubscribedFeature",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetSubscriptionRequest": {
                "fields": {
                  "subscriptionToken": {
                    "type": "string",
                    "id": 1
                  },
                  "subscriptionKey": {
                    "type": ".squareup.sub2.data.SubscriptionKey",
                    "id": 2
                  }
                },
                "nested": {
                  "subscription_descriptor": {
                    "oneof": ["subscriptionToken", "subscriptionKey"]
                  }
                }
              },
              "GetSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPlanComponentsRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetPlanComponentsResponse": {
                "fields": {
                  "components": {
                    "type": ".squareup.sub2.data.PlanComponent",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetBillerLocationTokenRequest": {
                "fields": {
                  "countryCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBillerLocationTokenResponse": {
                "fields": {
                  "locationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetPricingInfoRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "usageData": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 5,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 6,
                    "rule": "optional"
                  },
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includeEstimatedTax": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "bundleOfferingToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "bundleOfferingVersion": {
                    "type": "uint32",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "GetPricingInfoResponse": {
                "fields": {
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 1,
                    "rule": "optional"
                  },
                  "numFreeTrialDays": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "renewalCycle": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "estimatedCost": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "usageData": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 6,
                    "rule": "optional"
                  },
                  "estimatedTaxCost": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "estimatedSubtotal": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "estimatedTaxPercentage": {
                    "type": "int32",
                    "id": 9,
                    "rule": "optional"
                  },
                  "dueDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "estimatedProratedSubtotal": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "isProrated": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "estimatedProratedTotal": {
                    "type": ".squareup.common.Money",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "GetDefaultPricingInfoRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 3,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GetDefaultPricingInfoResponse": {
                "fields": {
                  "pricing": {
                    "type": ".squareup.sub2.data.Pricing",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUsageRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "newUsage": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 6,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 7,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "action": {
                    "type": ".squareup.sub2.service.UsageActionType",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": "AGGREGATED"
                    }
                  },
                  "discreteSettings": {
                    "type": ".squareup.sub2.service.DiscreteUsageSettings",
                    "id": 10,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUsageResponse": {
                "fields": {}
              },
              "ListSubscriptionsRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "include": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListSubscriptionsResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "bundles": {
                    "type": ".squareup.sub2.data.Bundle",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ListMergedSubscriptionsRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListMergedSubscriptionsResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "bundles": {
                    "type": ".squareup.sub2.data.Bundle",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ListSubscriptionHistoryRequest": {
                "fields": {
                  "subscriptionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListSubscriptionHistoryResponse": {
                "fields": {
                  "events": {
                    "type": ".squareup.sub2.data.SubscriptionHistoryEvent",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SubscriptionsForPaymentRequest": {
                "fields": {
                  "paymentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SubscriptionsForPaymentResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ExtendFreeTrialForSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "numDays": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2
                  },
                  "subscriptionKey": {
                    "type": ".squareup.sub2.data.SubscriptionKey",
                    "id": 8
                  }
                },
                "nested": {
                  "subscription_descriptor": {
                    "oneof": ["subscriptionToken", "subscriptionKey"]
                  }
                }
              },
              "ExtendFreeTrialForSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateFreeTrialDurationForSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "numDays": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "subscriptionToken": {
                    "type": "string",
                    "id": 2
                  },
                  "subscriptionKey": {
                    "type": ".squareup.sub2.data.SubscriptionKey",
                    "id": 8
                  }
                },
                "nested": {
                  "subscription_descriptor": {
                    "oneof": ["subscriptionToken", "subscriptionKey"]
                  }
                }
              },
              "UpdateFreeTrialDurationForSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListFeatureStatusesRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productOwner": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListFeatureStatusesResponse": {
                "fields": {
                  "featureStatuses": {
                    "type": ".squareup.sub2.service.ListFeatureStatusesResponse.FeatureStatus",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FeatureStatus": {
                    "fields": {
                      "feature": {
                        "type": ".squareup.sub2.data.Feature",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.sub2.common.SubscriptionStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "subscriptionToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ListActivePlansRequest": {
                "fields": {
                  "countryCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ListActivePlansResponse": {
                "fields": {
                  "plans": {
                    "type": ".squareup.sub2.data.Plan",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "externalPlans": {
                    "type": ".squareup.sub2.data.ExternalPlan",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListAvailablePlansRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListAvailablePlansResponse": {
                "fields": {
                  "plans": {
                    "type": ".squareup.sub2.data.Plan",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "externalPlans": {
                    "type": ".squareup.sub2.data.ExternalPlan",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListAvailableBundleOfferingsRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListAvailableBundleOfferingsResponse": {
                "fields": {
                  "bundleOfferings": {
                    "type": ".squareup.sub2.data.BundleOffering",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CreateBundleRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "bundleOfferingToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CreateBundleResponse": {
                "fields": {
                  "bundle": {
                    "type": ".squareup.sub2.data.Bundle",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CancelBundleRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "bundleToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CancelBundleResponse": {
                "fields": {
                  "bundle": {
                    "type": ".squareup.sub2.data.Bundle",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBundleRequest": {
                "fields": {
                  "bundleToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBundleResponse": {
                "fields": {
                  "bundle": {
                    "type": ".squareup.sub2.data.Bundle",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BatchCreateAndCancelSubscriptionsRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createRequests": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CreateSubscription",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "cancelRequests": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CancelSubscription",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "updateRequests": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription",
                    "id": 7,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CreateSubscription": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "customPricing": {
                        "type": ".squareup.sub2.data.Pricing",
                        "id": 2,
                        "rule": "optional"
                      },
                      "sendEmail": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "startInFreeTrialNoObligationState": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "customFreeTrialDuration": {
                        "type": ".squareup.sub2.data.Duration",
                        "id": 5,
                        "rule": "optional"
                      },
                      "planBillingCycle": {
                        "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                        "id": 6,
                        "rule": "optional"
                      },
                      "activationSource": {
                        "type": ".squareup.sub2.data.ActivationSource",
                        "id": 7,
                        "rule": "optional"
                      },
                      "expireAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "CancelSubscription": {
                    "fields": {
                      "subscriptionToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cancelImmediately": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "sendEmail": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "feedback": {
                        "type": ".squareup.sub2.data.Feedback",
                        "id": 5,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateSubscription": {
                    "fields": {
                      "subscription": {
                        "type": ".squareup.sub2.data.Subscription",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cancelFutureDowngrade": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "startInFreeTrialNoObligationState": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "feedback": {
                        "type": ".squareup.sub2.data.Feedback",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "sendEmail": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      }
                    }
                  }
                }
              },
              "BatchCreateAndCancelSubscriptionsResponse": {
                "fields": {
                  "created": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.CreatedSubscription",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "canceled": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.CanceledSubscription",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "updated": {
                    "type": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CreatedSubscription": {
                    "fields": {
                      "subscription": {
                        "type": ".squareup.sub2.data.Subscription",
                        "id": 1,
                        "rule": "optional"
                      },
                      "succeeded": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CanceledSubscription": {
                    "fields": {
                      "subscription": {
                        "type": ".squareup.sub2.data.Subscription",
                        "id": 1,
                        "rule": "optional"
                      },
                      "succeeded": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdatedSubscription": {
                    "fields": {
                      "subscription": {
                        "type": ".squareup.sub2.data.Subscription",
                        "id": 1,
                        "rule": "optional"
                      },
                      "succeeded": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BulkCreateSubscriptionsRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createSubscriptionParams": {
                    "type": ".squareup.sub2.service.BulkCreateSubscriptionsRequest.CreateSubscriptionParams",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "activationSource": {
                    "type": ".squareup.sub2.data.ActivationSource",
                    "id": 6,
                    "rule": "optional"
                  },
                  "autoConfigureSquareOneEligibility": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "StartingStatus": {
                    "values": {
                      "DEFAULT": 0,
                      "FREE_TRIAL": 1,
                      "FREE_TRIAL_NO_OBLIGATION": 2,
                      "ACTIVE": 3,
                      "PRESALE": 4
                    }
                  },
                  "CreateSubscriptionParams": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "planBillingCycle": {
                        "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                        "id": 2,
                        "rule": "optional"
                      },
                      "startingStatus": {
                        "type": ".squareup.sub2.service.BulkCreateSubscriptionsRequest.StartingStatus",
                        "id": 3,
                        "rule": "optional"
                      },
                      "customPricing": {
                        "type": ".squareup.sub2.data.Pricing",
                        "id": 4,
                        "rule": "optional"
                      },
                      "customFreeTrialDuration": {
                        "type": ".squareup.sub2.data.Duration",
                        "id": 5,
                        "rule": "optional"
                      },
                      "sendEmail": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "expireAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BulkCreateSubscriptionsResponse": {
                "fields": {
                  "created": {
                    "type": ".squareup.sub2.service.BulkCreateSubscriptionsResponse.CreatedSubscription",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CreatedSubscription": {
                    "fields": {
                      "succeeded": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subscription": {
                        "type": ".squareup.sub2.data.Subscription",
                        "id": 2,
                        "rule": "optional"
                      },
                      "planToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "errorMessage": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ListSubscribersRequest": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListSubscribersResponse": {
                "fields": {
                  "subscribers": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetAvailableFreeTrialRequest": {
                "fields": {
                  "subscriptionKey": {
                    "type": ".squareup.sub2.data.SubscriptionKey",
                    "id": 1,
                    "rule": "optional"
                  },
                  "remainingDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetAvailableFreeTrialResponse": {
                "fields": {}
              },
              "SetTierAvailableFreeTrialRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tierToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 4,
                    "rule": "optional"
                  },
                  "remainingDuration": {
                    "type": ".squareup.sub2.data.Duration",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "SetTierAvailableFreeTrialResponse": {
                "fields": {}
              },
              "GetUiAssetsRequest": {
                "fields": {
                  "planGroupToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ui": {
                    "type": ".squareup.sub2.service.GetUiAssetsRequest.Ui",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "subaudience": {
                    "type": ".squareup.precog.api.v2.Subaudience",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Ui": {
                    "values": {
                      "DO_NOT_USE_UI": 0,
                      "FULL_PAGE_PAYWALL": 1,
                      "MODAL": 2,
                      "PAYWALL_CARD": 3,
                      "DOWNGRADE": 4,
                      "TRIAL_WELCOME": 5,
                      "TRIAL_EXPIRING": 6,
                      "TRIAL_EXPIRED": 7,
                      "MIGRATION_OPT_IN": 8,
                      "MIGRATION_OPT_OUT": 9,
                      "DEFAULT_PROCESSING_FEES": 10,
                      "FEATURE_LOSS": 11,
                      "FEATURE_GRID": 12
                    }
                  }
                }
              },
              "GetUiAssetsResponse": {
                "fields": {
                  "fullPagePaywall": {
                    "type": ".squareup.sub2.assets.FullPagePaywall",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modal": {
                    "type": ".squareup.sub2.assets.Modal",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paywallCard": {
                    "type": ".squareup.sub2.assets.PaywallCard",
                    "id": 3,
                    "rule": "optional"
                  },
                  "downgrade": {
                    "type": ".squareup.sub2.assets.Downgrade",
                    "id": 4,
                    "rule": "optional"
                  },
                  "trialWelcome": {
                    "type": ".squareup.sub2.assets.TrialWelcome",
                    "id": 5,
                    "rule": "optional"
                  },
                  "trialExpiring": {
                    "type": ".squareup.sub2.assets.TrialExpiring",
                    "id": 6,
                    "rule": "optional"
                  },
                  "trialExpired": {
                    "type": ".squareup.sub2.assets.TrialExpired",
                    "id": 7,
                    "rule": "optional"
                  },
                  "migrationOptIn": {
                    "type": ".squareup.sub2.assets.MigrationOptIn",
                    "id": 8,
                    "rule": "optional"
                  },
                  "migrationOptOut": {
                    "type": ".squareup.sub2.assets.MigrationOptOut",
                    "id": 9,
                    "rule": "optional"
                  },
                  "defaultProcessingFees": {
                    "type": ".squareup.sub2.assets.DefaultProcessingFees",
                    "id": 10,
                    "rule": "optional"
                  },
                  "featureLoss": {
                    "type": ".squareup.sub2.assets.FeatureLoss",
                    "id": 11,
                    "rule": "optional"
                  },
                  "featureGrid": {
                    "type": ".squareup.sub2.assets.FeatureGrid",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "GetPlanGroupRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "usageData": {
                    "type": ".squareup.sub2.data.Usage",
                    "id": 3,
                    "rule": "optional"
                  },
                  "groupBillingCycle": {
                    "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 4,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetPlanGroupResponse": {
                "fields": {
                  "planGroup": {
                    "type": ".squareup.sub2.data.PlanGroup",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BulkGetFeatureDiffRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planChanges": {
                    "type": ".squareup.sub2.service.BulkGetFeatureDiffRequest.PlanChange",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PlanChange": {
                    "fields": {
                      "currentPlanToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "currentPlanBillingCycle": {
                        "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                        "id": 2,
                        "rule": "optional"
                      },
                      "newPlanToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "newPlanBillingCycle": {
                        "type": ".squareup.billing.data.SubscriptionFeeBillCycle",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BulkGetFeatureDiffResponse": {
                "fields": {
                  "featureDiffs": {
                    "type": ".squareup.sub2.service.BulkGetFeatureDiffResponse.FeatureDiff",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FeatureDiff": {
                    "fields": {
                      "succeeded": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "featuresLost": {
                        "type": ".squareup.sub2.data.DisplayedFeature",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "featuresMaintained": {
                        "type": ".squareup.sub2.data.DisplayedFeature",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "featuresGained": {
                        "type": ".squareup.sub2.data.DisplayedFeature",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "errorMessage": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CreateFeedbackOptionRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "inputType": {
                    "type": ".squareup.sub2.data.FeedbackOption.InputType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "secondaryOptionTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "CreateFeedbackOptionResponse": {
                "fields": {
                  "feedbackOption": {
                    "type": ".squareup.sub2.data.FeedbackOption",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveFeedbackOptionRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveFeedbackOptionResponse": {
                "fields": {
                  "feedbackOption": {
                    "type": ".squareup.sub2.data.FeedbackOption",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateFeedbackOptionListRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feedbackOptionTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreateFeedbackOptionListResponse": {
                "fields": {
                  "feedbackOptionList": {
                    "type": ".squareup.sub2.data.FeedbackOptionList",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveFeedbackOptionListRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveFeedbackOptionListResponse": {
                "fields": {
                  "feedbackOptionList": {
                    "type": ".squareup.sub2.data.FeedbackOptionList",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateFeedbackOptionListRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feedbackOptionTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateFeedbackOptionListResponse": {
                "fields": {
                  "feedbackOptionList": {
                    "type": ".squareup.sub2.data.FeedbackOptionList",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetFeedbackOptionListForPlanRequest": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetFeedbackOptionListForPlanResponse": {
                "fields": {
                  "feedbackOptionList": {
                    "type": ".squareup.sub2.data.FeedbackOptionList",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetFutureSubscribedFeatureDiffRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "oldPlanTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "newPlanTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetFutureSubscribedFeatureDiffResponse": {
                "fields": {
                  "futureSubscribedFeatures": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "futureSubscribedFeaturesWithPlanChange": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "SyncSquareOneAvtBucketingResultRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "avt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "assignedVariant": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SyncSquareOneAvtBucketingResultResponse": {
                "fields": {
                  "avtBucketed": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "squareOneEligibility": {
                    "type": ".squareup.sub2.data.SquareOneEligibility",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SquareOneEligibilityOverride": {
                "fields": {
                  "isEligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetOrSetSquareOneEligibilityRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibilityQualifier": {
                    "type": ".squareup.sub2.data.EligibilityQualifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "override": {
                    "type": ".squareup.sub2.service.SquareOneEligibilityOverride",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MigrationExperiment": {
                "fields": {
                  "experimentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "experimentType": {
                    "type": ".squareup.sub2.service.MigrationExperiment.ExperimentType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "experimentStartDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "experimentAutoMigrateDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "experimentPlanToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "experimentPlanGroupToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "subscriberDecision": {
                    "type": ".squareup.sub2.data.SquareOneMigrationStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "migrationOutcome": {
                    "type": ".squareup.sub2.data.MigrationOutcome",
                    "id": 8,
                    "rule": "optional"
                  },
                  "treatmentToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ExperimentType": {
                    "values": {
                      "DO_NOT_USE_EXPERIMENT_TYPE": 0,
                      "AUTO_MIGRATE": 1,
                      "REQUIRES_OPT_IN": 2
                    }
                  }
                }
              },
              "GetOrSetSquareOneEligibilityResponse": {
                "fields": {
                  "squareOneEligibility": {
                    "type": ".squareup.sub2.data.SquareOneEligibility",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activeMigrationExperiment": {
                    "type": ".squareup.sub2.service.MigrationExperiment",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gaMigrationEligibility": {
                    "type": ".squareup.sub2.data.GaMigrationEligibility",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetTierRecommendationRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetTierRecommendationResponse": {
                "fields": {
                  "recommendedPlanToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSquareOneSubscriptionInfoRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includePlanInfo": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetSquareOneSubscriptionInfoResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recommendedTierPlanToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "freeTierPlanToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planGroup": {
                    "type": ".squareup.sub2.data.PlanGroup",
                    "id": 4,
                    "rule": "optional"
                  },
                  "trialInfo": {
                    "type": ".squareup.sub2.service.GetSquareOneSubscriptionInfoResponse.TrialInfo",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "previousSubscriptionState": {
                    "type": ".squareup.sub2.service.GetSquareOneSubscriptionInfoResponse.PreviousSubscriptionState",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TrialInfo": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "obligated": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tierToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "PreviousSubscriptionState": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subscriptionStatus": {
                        "type": ".squareup.sub2.common.SubscriptionStatus",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CreateSquareOneSubscriptionIfEligibleRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibilityQualifier": {
                    "type": ".squareup.sub2.data.EligibilityQualifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotenceToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tierToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sendEmail": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "activationSource": {
                    "type": ".squareup.sub2.data.ActivationSource",
                    "id": 8,
                    "rule": "optional"
                  },
                  "override": {
                    "type": ".squareup.sub2.service.SquareOneEligibilityOverride",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "CreateSquareOneSubscriptionIfEligibleResponse": {
                "fields": {
                  "squareOneEligibility": {
                    "type": ".squareup.sub2.data.SquareOneEligibility",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListTrialsRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListTrialsResponse": {
                "fields": {
                  "activeTrial": {
                    "type": ".squareup.sub2.data.ActiveTrial",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availableTrials": {
                    "type": ".squareup.sub2.data.AvailableTrial",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "consumedTrials": {
                    "type": ".squareup.sub2.data.ConsumedTrial",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ForceTransitionSubscriptionRequest": {
                "fields": {
                  "subscriptionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "targetStatus": {
                    "type": ".squareup.sub2.common.SubscriptionStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ForceTransitionSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSquareOnePlansRequest": {
                "fields": {}
              },
              "GetSquareOnePlansResponse": {
                "fields": {
                  "squareOnePlans": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "compatiblePlans": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "SetSquareOneMigrationDecisionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "experimentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "newMigrationStatus": {
                    "type": ".squareup.sub2.data.SquareOneMigrationStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SetSquareOneMigrationDecisionResponse": {
                "fields": {
                  "experimentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "migrationStatus": {
                    "type": ".squareup.sub2.data.SquareOneMigrationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateMigrationEnrollmentsRequest": {
                "fields": {
                  "experimentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriberTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "promotionalTreatmentToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateMigrationEnrollmentsResponse": {
                "fields": {
                  "migrationExperiments": {
                    "type": ".squareup.sub2.service.MigrationExperiment",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetSquareOneMigrationFeaturesRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetSquareOneMigrationFeaturesResponse": {
                "fields": {
                  "features": {
                    "type": ".squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.FeaturesByPlan",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FeaturesByPlan": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "features": {
                        "type": ".squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.FeaturePlanEntry",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "planName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "FeaturePlanEntry": {
                    "fields": {
                      "feature": {
                        "type": ".squareup.sub2.data.Feature",
                        "id": 1,
                        "rule": "optional"
                      },
                      "entitlements": {
                        "type": ".squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.EntitlementByPlan",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "featureName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "EntitlementByPlan": {
                    "fields": {
                      "planToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isEntitled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetSquareOneLostFeaturesRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "LostFeaturesByPlan": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lostFeatures": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "GetSquareOneLostFeaturesResponse": {
                "fields": {
                  "lostFeaturesByPlan": {
                    "type": ".squareup.sub2.service.LostFeaturesByPlan",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MigrateToSquareOneRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "migrationTiming": {
                    "type": ".squareup.sub2.data.MigrateToSquareOneTiming",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MigrateToSquareOneResponse": {
                "fields": {
                  "migrationStatus": {
                    "type": ".squareup.sub2.data.MigrationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 2,
                    "rule": "optional"
                  },
                  "activationAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SyncBillableLocationRequest": {
                "fields": {
                  "subscriber": {
                    "type": ".squareup.sub2.data.Entity",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SyncBillableLocationResponse": {
                "fields": {
                  "succeeded": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SubscriptionService": {
                "methods": {
                  "CreateOrUpdateSubscription": {
                    "requestType": ".squareup.sub2.service.CreateOrUpdateSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.CreateOrUpdateSubscriptionResponse"
                  },
                  "CreateSquareOneSubscriptionForOnboardedMerchant": {
                    "requestType": ".squareup.sub2.service.CreateSquareOneSubscriptionForOnboardedMerchantRequest",
                    "responseType": ".squareup.sub2.service.CreateSquareOneSubscriptionForOnboardedMerchantResponse"
                  },
                  "CreateSubscription": {
                    "requestType": ".squareup.sub2.service.CreateSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.CreateSubscriptionResponse"
                  },
                  "UpdateSubscription": {
                    "requestType": ".squareup.sub2.service.UpdateSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.UpdateSubscriptionResponse"
                  },
                  "ActivatePresaleSubscriptions": {
                    "requestType": ".squareup.sub2.service.ActivatePresaleSubscriptionsRequest",
                    "responseType": ".squareup.sub2.service.ActivatePresaleSubscriptionsResponse"
                  },
                  "UpdatePresaleSubscription": {
                    "requestType": ".squareup.sub2.service.UpdatePresaleSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.UpdatePresaleSubscriptionResponse"
                  },
                  "CancelSubscription": {
                    "requestType": ".squareup.sub2.service.CancelSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.CancelSubscriptionResponse"
                  },
                  "PauseSubscription": {
                    "requestType": ".squareup.sub2.service.PauseSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.PauseSubscriptionResponse"
                  },
                  "ResumeSubscription": {
                    "requestType": ".squareup.sub2.service.ResumeSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.ResumeSubscriptionResponse"
                  },
                  "ListSubscribedFeatures": {
                    "requestType": ".squareup.sub2.service.ListSubscribedFeaturesRequest",
                    "responseType": ".squareup.sub2.service.ListSubscribedFeaturesResponse"
                  },
                  "GetSubscription": {
                    "requestType": ".squareup.sub2.service.GetSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.GetSubscriptionResponse"
                  },
                  "GetPlanComponents": {
                    "requestType": ".squareup.sub2.service.GetPlanComponentsRequest",
                    "responseType": ".squareup.sub2.service.GetPlanComponentsResponse"
                  },
                  "GetBillerLocationToken": {
                    "requestType": ".squareup.sub2.service.GetBillerLocationTokenRequest",
                    "responseType": ".squareup.sub2.service.GetBillerLocationTokenResponse"
                  },
                  "UpdateUsage": {
                    "requestType": ".squareup.sub2.service.UpdateUsageRequest",
                    "responseType": ".squareup.sub2.service.UpdateUsageResponse"
                  },
                  "IsSubscribedToFeature": {
                    "requestType": ".squareup.sub2.service.IsSubscribedToFeatureRequest",
                    "responseType": ".squareup.sub2.service.IsSubscribedToFeatureResponse"
                  },
                  "ListSubscriptions": {
                    "requestType": ".squareup.sub2.service.ListSubscriptionsRequest",
                    "responseType": ".squareup.sub2.service.ListSubscriptionsResponse"
                  },
                  "ListMergedSubscriptions": {
                    "requestType": ".squareup.sub2.service.ListMergedSubscriptionsRequest",
                    "responseType": ".squareup.sub2.service.ListMergedSubscriptionsResponse"
                  },
                  "ListSubscriptionHistory": {
                    "requestType": ".squareup.sub2.service.ListSubscriptionHistoryRequest",
                    "responseType": ".squareup.sub2.service.ListSubscriptionHistoryResponse"
                  },
                  "SubscriptionsForPayment": {
                    "requestType": ".squareup.sub2.service.SubscriptionsForPaymentRequest",
                    "responseType": ".squareup.sub2.service.SubscriptionsForPaymentResponse"
                  },
                  "ExtendFreeTrialForSubscription": {
                    "requestType": ".squareup.sub2.service.ExtendFreeTrialForSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.ExtendFreeTrialForSubscriptionResponse"
                  },
                  "GetPricingInfo": {
                    "requestType": ".squareup.sub2.service.GetPricingInfoRequest",
                    "responseType": ".squareup.sub2.service.GetPricingInfoResponse"
                  },
                  "GetDefaultPricingInfo": {
                    "requestType": ".squareup.sub2.service.GetDefaultPricingInfoRequest",
                    "responseType": ".squareup.sub2.service.GetDefaultPricingInfoResponse"
                  },
                  "ListFeatureStatuses": {
                    "requestType": ".squareup.sub2.service.ListFeatureStatusesRequest",
                    "responseType": ".squareup.sub2.service.ListFeatureStatusesResponse"
                  },
                  "BatchCreateAndCancelSubscriptions": {
                    "requestType": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest",
                    "responseType": ".squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse"
                  },
                  "BulkCreateSubscriptions": {
                    "requestType": ".squareup.sub2.service.BulkCreateSubscriptionsRequest",
                    "responseType": ".squareup.sub2.service.BulkCreateSubscriptionsResponse"
                  },
                  "ListAvailablePlans": {
                    "requestType": ".squareup.sub2.service.ListAvailablePlansRequest",
                    "responseType": ".squareup.sub2.service.ListAvailablePlansResponse"
                  },
                  "ListActivePlans": {
                    "requestType": ".squareup.sub2.service.ListActivePlansRequest",
                    "responseType": ".squareup.sub2.service.ListActivePlansResponse"
                  },
                  "ListAvailableBundleOfferings": {
                    "requestType": ".squareup.sub2.service.ListAvailableBundleOfferingsRequest",
                    "responseType": ".squareup.sub2.service.ListAvailableBundleOfferingsResponse"
                  },
                  "CreateBundle": {
                    "requestType": ".squareup.sub2.service.CreateBundleRequest",
                    "responseType": ".squareup.sub2.service.CreateBundleResponse"
                  },
                  "CancelBundle": {
                    "requestType": ".squareup.sub2.service.CancelBundleRequest",
                    "responseType": ".squareup.sub2.service.CancelBundleResponse"
                  },
                  "GetBundle": {
                    "requestType": ".squareup.sub2.service.GetBundleRequest",
                    "responseType": ".squareup.sub2.service.GetBundleResponse"
                  },
                  "ListSubscribers": {
                    "requestType": ".squareup.sub2.service.ListSubscribersRequest",
                    "responseType": ".squareup.sub2.service.ListSubscribersResponse"
                  },
                  "SetAvailableFreeTrial": {
                    "requestType": ".squareup.sub2.service.SetAvailableFreeTrialRequest",
                    "responseType": ".squareup.sub2.service.SetAvailableFreeTrialResponse"
                  },
                  "SetTierAvailableFreeTrial": {
                    "requestType": ".squareup.sub2.service.SetTierAvailableFreeTrialRequest",
                    "responseType": ".squareup.sub2.service.SetTierAvailableFreeTrialResponse"
                  },
                  "GetPlanGroup": {
                    "requestType": ".squareup.sub2.service.GetPlanGroupRequest",
                    "responseType": ".squareup.sub2.service.GetPlanGroupResponse"
                  },
                  "BulkGetFeatureDiff": {
                    "requestType": ".squareup.sub2.service.BulkGetFeatureDiffRequest",
                    "responseType": ".squareup.sub2.service.BulkGetFeatureDiffResponse"
                  },
                  "CreateFeedbackOption": {
                    "requestType": ".squareup.sub2.service.CreateFeedbackOptionRequest",
                    "responseType": ".squareup.sub2.service.CreateFeedbackOptionResponse"
                  },
                  "RetrieveFeedbackOption": {
                    "requestType": ".squareup.sub2.service.RetrieveFeedbackOptionRequest",
                    "responseType": ".squareup.sub2.service.RetrieveFeedbackOptionResponse"
                  },
                  "CreateFeedbackOptionList": {
                    "requestType": ".squareup.sub2.service.CreateFeedbackOptionListRequest",
                    "responseType": ".squareup.sub2.service.CreateFeedbackOptionListResponse"
                  },
                  "RetrieveFeedbackOptionList": {
                    "requestType": ".squareup.sub2.service.RetrieveFeedbackOptionListRequest",
                    "responseType": ".squareup.sub2.service.RetrieveFeedbackOptionListResponse"
                  },
                  "UpdateFeedbackOptionList": {
                    "requestType": ".squareup.sub2.service.UpdateFeedbackOptionListRequest",
                    "responseType": ".squareup.sub2.service.UpdateFeedbackOptionListResponse"
                  },
                  "GetFeedbackOptionListForPlan": {
                    "requestType": ".squareup.sub2.service.GetFeedbackOptionListForPlanRequest",
                    "responseType": ".squareup.sub2.service.GetFeedbackOptionListForPlanResponse"
                  },
                  "GetFutureSubscribedFeatureDiff": {
                    "requestType": ".squareup.sub2.service.GetFutureSubscribedFeatureDiffRequest",
                    "responseType": ".squareup.sub2.service.GetFutureSubscribedFeatureDiffResponse"
                  },
                  "SyncSquareOneAvtBucketingResult": {
                    "requestType": ".squareup.sub2.service.SyncSquareOneAvtBucketingResultRequest",
                    "responseType": ".squareup.sub2.service.SyncSquareOneAvtBucketingResultResponse"
                  },
                  "GetOrSetSquareOneEligibility": {
                    "requestType": ".squareup.sub2.service.GetOrSetSquareOneEligibilityRequest",
                    "responseType": ".squareup.sub2.service.GetOrSetSquareOneEligibilityResponse"
                  },
                  "ListTrials": {
                    "requestType": ".squareup.sub2.service.ListTrialsRequest",
                    "responseType": ".squareup.sub2.service.ListTrialsResponse"
                  },
                  "GetTierRecommendation": {
                    "requestType": ".squareup.sub2.service.GetTierRecommendationRequest",
                    "responseType": ".squareup.sub2.service.GetTierRecommendationResponse"
                  },
                  "GetSquareOneSubscriptionInfo": {
                    "requestType": ".squareup.sub2.service.GetSquareOneSubscriptionInfoRequest",
                    "responseType": ".squareup.sub2.service.GetSquareOneSubscriptionInfoResponse"
                  },
                  "CreateSquareOneSubscriptionIfEligible": {
                    "requestType": ".squareup.sub2.service.CreateSquareOneSubscriptionIfEligibleRequest",
                    "responseType": ".squareup.sub2.service.CreateSquareOneSubscriptionIfEligibleResponse"
                  },
                  "ForceTransitionSubscription": {
                    "requestType": ".squareup.sub2.service.ForceTransitionSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.ForceTransitionSubscriptionResponse"
                  },
                  "UpdateFreeTrialDurationForSubscription": {
                    "requestType": ".squareup.sub2.service.UpdateFreeTrialDurationForSubscriptionRequest",
                    "responseType": ".squareup.sub2.service.UpdateFreeTrialDurationForSubscriptionResponse"
                  },
                  "GetUiAssets": {
                    "requestType": ".squareup.sub2.service.GetUiAssetsRequest",
                    "responseType": ".squareup.sub2.service.GetUiAssetsResponse"
                  },
                  "SyncBillableLocation": {
                    "requestType": ".squareup.sub2.service.SyncBillableLocationRequest",
                    "responseType": ".squareup.sub2.service.SyncBillableLocationResponse"
                  },
                  "GetSquareOnePlans": {
                    "requestType": ".squareup.sub2.service.GetSquareOnePlansRequest",
                    "responseType": ".squareup.sub2.service.GetSquareOnePlansResponse"
                  },
                  "SetSquareOneMigrationDecision": {
                    "requestType": ".squareup.sub2.service.SetSquareOneMigrationDecisionRequest",
                    "responseType": ".squareup.sub2.service.SetSquareOneMigrationDecisionResponse"
                  },
                  "CreateMigrationEnrollments": {
                    "requestType": ".squareup.sub2.service.CreateMigrationEnrollmentsRequest",
                    "responseType": ".squareup.sub2.service.CreateMigrationEnrollmentsResponse"
                  },
                  "GetSquareOneMigrationFeatures": {
                    "requestType": ".squareup.sub2.service.GetSquareOneMigrationFeaturesRequest",
                    "responseType": ".squareup.sub2.service.GetSquareOneMigrationFeaturesResponse"
                  },
                  "GetSquareOneLostFeatures": {
                    "requestType": ".squareup.sub2.service.GetSquareOneLostFeaturesRequest",
                    "responseType": ".squareup.sub2.service.GetSquareOneLostFeaturesResponse"
                  },
                  "MigrateToSquareOne": {
                    "requestType": ".squareup.sub2.service.MigrateToSquareOneRequest",
                    "responseType": ".squareup.sub2.service.MigrateToSquareOneResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UsageActionType && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UsageMode && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.DiscreteUsageSettings && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateOrUpdateSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateOrUpdateSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSquareOneSubscriptionForOnboardedMerchantRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSquareOneSubscriptionForOnboardedMerchantResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ActivatePresaleSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ActivatePresaleSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdatePresaleSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdatePresaleSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CancelSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CancelSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.PauseSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.PauseSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ResumeSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ResumeSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.IsSubscribedToFeatureRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.IsSubscribedToFeatureResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscribedFeaturesRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscribedFeaturesResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPlanComponentsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPlanComponentsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetBillerLocationTokenRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetBillerLocationTokenResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPricingInfoRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPricingInfoResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetDefaultPricingInfoRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetDefaultPricingInfoResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateUsageRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateUsageResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListMergedSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListMergedSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscriptionHistoryRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscriptionHistoryResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SubscriptionsForPaymentRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SubscriptionsForPaymentResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ExtendFreeTrialForSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ExtendFreeTrialForSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateFreeTrialDurationForSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateFreeTrialDurationForSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListFeatureStatusesRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListFeatureStatusesResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListFeatureStatusesResponse?.nested?.FeatureStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListActivePlansRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListActivePlansResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListAvailablePlansRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListAvailablePlansResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListAvailableBundleOfferingsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListAvailableBundleOfferingsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CancelBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CancelBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsRequest?.nested?.CreateSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsRequest?.nested?.CancelSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsRequest?.nested?.UpdateSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsResponse?.nested?.CreatedSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsResponse?.nested?.CanceledSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BatchCreateAndCancelSubscriptionsResponse?.nested?.UpdatedSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkCreateSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkCreateSubscriptionsRequest?.nested?.StartingStatus && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkCreateSubscriptionsRequest?.nested?.CreateSubscriptionParams && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkCreateSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkCreateSubscriptionsResponse?.nested?.CreatedSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscribersRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListSubscribersResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetAvailableFreeTrialRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetAvailableFreeTrialResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetTierAvailableFreeTrialRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetTierAvailableFreeTrialResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetUiAssetsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetUiAssetsRequest?.nested?.Ui && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetUiAssetsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPlanGroupRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetPlanGroupResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkGetFeatureDiffRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkGetFeatureDiffRequest?.nested?.PlanChange && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkGetFeatureDiffResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.BulkGetFeatureDiffResponse?.nested?.FeatureDiff && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateFeedbackOptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateFeedbackOptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.RetrieveFeedbackOptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.RetrieveFeedbackOptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateFeedbackOptionListRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateFeedbackOptionListResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.RetrieveFeedbackOptionListRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.RetrieveFeedbackOptionListResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateFeedbackOptionListRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.UpdateFeedbackOptionListResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetFeedbackOptionListForPlanRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetFeedbackOptionListForPlanResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetFutureSubscribedFeatureDiffRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetFutureSubscribedFeatureDiffResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SyncSquareOneAvtBucketingResultRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SyncSquareOneAvtBucketingResultResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SquareOneEligibilityOverride && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetOrSetSquareOneEligibilityRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.MigrationExperiment && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.MigrationExperiment?.nested?.ExperimentType && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetOrSetSquareOneEligibilityResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetTierRecommendationRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetTierRecommendationResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneSubscriptionInfoRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneSubscriptionInfoResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneSubscriptionInfoResponse?.nested?.TrialInfo && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneSubscriptionInfoResponse?.nested?.PreviousSubscriptionState && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSquareOneSubscriptionIfEligibleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateSquareOneSubscriptionIfEligibleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListTrialsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ListTrialsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ForceTransitionSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.ForceTransitionSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOnePlansRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOnePlansResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetSquareOneMigrationDecisionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SetSquareOneMigrationDecisionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateMigrationEnrollmentsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.CreateMigrationEnrollmentsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneMigrationFeaturesRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneMigrationFeaturesResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneMigrationFeaturesResponse?.nested?.FeaturesByPlan && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneMigrationFeaturesResponse?.nested?.FeaturePlanEntry && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneMigrationFeaturesResponse?.nested?.EntitlementByPlan && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneLostFeaturesRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.LostFeaturesByPlan && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.GetSquareOneLostFeaturesResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.MigrateToSquareOneRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.MigrateToSquareOneResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SyncBillableLocationRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SyncBillableLocationResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.SubscriptionService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UsageActionType @ squareup/sub2/subscription_service.proto at 24:1
 */
export const UsageActionType = $root.lookupEnum('squareup.sub2.service.UsageActionType').values;
/**
 * SOURCE UsageMode @ squareup/sub2/subscription_service.proto at 35:1
 */
export const UsageMode = $root.lookupEnum('squareup.sub2.service.UsageMode').values;
/**
 * Setting for discrete usages.
 *
 * SOURCE DiscreteUsageSettings @ squareup/sub2/subscription_service.proto at 52:1
 */
export const DiscreteUsageSettings = $root.lookupType('squareup.sub2.service.DiscreteUsageSettings');
fixType(DiscreteUsageSettings);
Builder.createAndAttachToType(DiscreteUsageSettings);
/**
 * SOURCE CreateOrUpdateSubscriptionRequest @ squareup/sub2/subscription_service.proto at 57:1
 */
export const CreateOrUpdateSubscriptionRequest = $root.lookupType('squareup.sub2.service.CreateOrUpdateSubscriptionRequest');
fixType(CreateOrUpdateSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(CreateOrUpdateSubscriptionRequest);
/**
 * CreateOrUpdateSubscriptionResponse contains the subscription that was created or updated, or
 * no subscription on error.
 *
 * SOURCE CreateOrUpdateSubscriptionResponse @ squareup/sub2/subscription_service.proto at 118:1
 */
export const CreateOrUpdateSubscriptionResponse = $root.lookupType('squareup.sub2.service.CreateOrUpdateSubscriptionResponse');
fixType(CreateOrUpdateSubscriptionResponse);
Builder.createAndAttachToType(CreateOrUpdateSubscriptionResponse);
/**
 * SOURCE CreateSquareOneSubscriptionForOnboardedMerchantRequest @ squareup/sub2/subscription_service.proto at 123:1
 */
export const CreateSquareOneSubscriptionForOnboardedMerchantRequest = $root.lookupType('squareup.sub2.service.CreateSquareOneSubscriptionForOnboardedMerchantRequest');
fixType(CreateSquareOneSubscriptionForOnboardedMerchantRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  assignSquarePlan: {
    required: true
  }
});
Builder.createAndAttachToType(CreateSquareOneSubscriptionForOnboardedMerchantRequest);
/**
 * SOURCE CreateSquareOneSubscriptionForOnboardedMerchantResponse @ squareup/sub2/subscription_service.proto at 159:1
 */
export const CreateSquareOneSubscriptionForOnboardedMerchantResponse = $root.lookupType('squareup.sub2.service.CreateSquareOneSubscriptionForOnboardedMerchantResponse');
fixType(CreateSquareOneSubscriptionForOnboardedMerchantResponse);
Builder.createAndAttachToType(CreateSquareOneSubscriptionForOnboardedMerchantResponse);
/**
 * [DEPRECATED] CreateSubscriptionRequest is used when we want to create a brand new subscription for a merchant.
 * In comparison to CreateOrUpdateSubscriptionRequest, the endpoint here uses a declarative approach to handle
 * subscription statues.
 *
 * SOURCE CreateSubscriptionRequest @ squareup/sub2/subscription_service.proto at 170:1
 */
export const CreateSubscriptionRequest = $root.lookupType('squareup.sub2.service.CreateSubscriptionRequest');
fixType(CreateSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  planToken: {
    required: true
  },
  subscriptionStatus: {
    required: true
  }
});
Builder.createAndAttachToType(CreateSubscriptionRequest);
/**
 * CreateSubscriptionResponse contains the subscription that was created or no subscription on error.
 *
 * SOURCE CreateSubscriptionResponse @ squareup/sub2/subscription_service.proto at 217:1
 */
export const CreateSubscriptionResponse = $root.lookupType('squareup.sub2.service.CreateSubscriptionResponse');
fixType(CreateSubscriptionResponse);
Builder.createAndAttachToType(CreateSubscriptionResponse);
/**
 * ActivatePresaleSubscriptionsRequest is used when we want to activate all the
 *  presale subscriptions for a merchant.
 *
 * SOURCE ActivatePresaleSubscriptionsRequest @ squareup/sub2/subscription_service.proto at 225:1
 */
export const ActivatePresaleSubscriptionsRequest = $root.lookupType('squareup.sub2.service.ActivatePresaleSubscriptionsRequest');
fixType(ActivatePresaleSubscriptionsRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  actor: {
    required: true
  },
  reason: {
    required: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ActivatePresaleSubscriptionsRequest);
/**
 * ActivatePresaleSubscriptionsResponse contains the subscriptions that were activated from the presale state.
 *
 * SOURCE ActivatePresaleSubscriptionsResponse @ squareup/sub2/subscription_service.proto at 243:1
 */
export const ActivatePresaleSubscriptionsResponse = $root.lookupType('squareup.sub2.service.ActivatePresaleSubscriptionsResponse');
fixType(ActivatePresaleSubscriptionsResponse);
Builder.createAndAttachToType(ActivatePresaleSubscriptionsResponse);
/**
 * UpdatePresaleSubscriptionRequest is used when we want to put a cancelled subscription back to the presale state.
 *
 * SOURCE UpdatePresaleSubscriptionRequest @ squareup/sub2/subscription_service.proto at 249:1
 */
export const UpdatePresaleSubscriptionRequest = $root.lookupType('squareup.sub2.service.UpdatePresaleSubscriptionRequest');
fixType(UpdatePresaleSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriptionToken: {
    required: true
  },
  actor: {
    required: true
  },
  reason: {
    required: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(UpdatePresaleSubscriptionRequest);
/**
 * UpdatePresaleSubscriptionResponse contains the subscription that was put back to the presale state.
 *
 * SOURCE UpdatePresaleSubscriptionResponse @ squareup/sub2/subscription_service.proto at 270:1
 */
export const UpdatePresaleSubscriptionResponse = $root.lookupType('squareup.sub2.service.UpdatePresaleSubscriptionResponse');
fixType(UpdatePresaleSubscriptionResponse);
Builder.createAndAttachToType(UpdatePresaleSubscriptionResponse);
/**
 * SOURCE UpdateSubscriptionRequest @ squareup/sub2/subscription_service.proto at 275:1
 */
export const UpdateSubscriptionRequest = $root.lookupType('squareup.sub2.service.UpdateSubscriptionRequest');
fixType(UpdateSubscriptionRequest, {
  subscription: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateSubscriptionRequest);
/**
 * UpdateSubscriptionResponse contains the subscription that was updated or no subscription on error.
 *
 * SOURCE UpdateSubscriptionResponse @ squareup/sub2/subscription_service.proto at 302:1
 */
export const UpdateSubscriptionResponse = $root.lookupType('squareup.sub2.service.UpdateSubscriptionResponse');
fixType(UpdateSubscriptionResponse);
Builder.createAndAttachToType(UpdateSubscriptionResponse);
/**
 * SOURCE CancelSubscriptionRequest @ squareup/sub2/subscription_service.proto at 307:1
 */
export const CancelSubscriptionRequest = $root.lookupType('squareup.sub2.service.CancelSubscriptionRequest');
fixType(CancelSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(CancelSubscriptionRequest);
/**
 * SOURCE CancelSubscriptionResponse @ squareup/sub2/subscription_service.proto at 338:1
 */
export const CancelSubscriptionResponse = $root.lookupType('squareup.sub2.service.CancelSubscriptionResponse');
fixType(CancelSubscriptionResponse);
Builder.createAndAttachToType(CancelSubscriptionResponse);
/**
 * SOURCE PauseSubscriptionRequest @ squareup/sub2/subscription_service.proto at 343:1
 */
export const PauseSubscriptionRequest = $root.lookupType('squareup.sub2.service.PauseSubscriptionRequest');
fixType(PauseSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriptionToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(PauseSubscriptionRequest);
/**
 * SOURCE PauseSubscriptionResponse @ squareup/sub2/subscription_service.proto at 372:1
 */
export const PauseSubscriptionResponse = $root.lookupType('squareup.sub2.service.PauseSubscriptionResponse');
fixType(PauseSubscriptionResponse);
Builder.createAndAttachToType(PauseSubscriptionResponse);
/**
 * SOURCE ResumeSubscriptionRequest @ squareup/sub2/subscription_service.proto at 377:1
 */
export const ResumeSubscriptionRequest = $root.lookupType('squareup.sub2.service.ResumeSubscriptionRequest');
fixType(ResumeSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriptionToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ResumeSubscriptionRequest);
/**
 * SOURCE ResumeSubscriptionResponse @ squareup/sub2/subscription_service.proto at 394:1
 */
export const ResumeSubscriptionResponse = $root.lookupType('squareup.sub2.service.ResumeSubscriptionResponse');
fixType(ResumeSubscriptionResponse);
Builder.createAndAttachToType(ResumeSubscriptionResponse);
/**
 * SOURCE IsSubscribedToFeatureRequest @ squareup/sub2/subscription_service.proto at 399:1
 */
export const IsSubscribedToFeatureRequest = $root.lookupType('squareup.sub2.service.IsSubscribedToFeatureRequest');
fixType(IsSubscribedToFeatureRequest, {
  subscriber: {
    required: true
  },
  feature: {
    required: true
  }
});
Builder.createAndAttachToType(IsSubscribedToFeatureRequest);
/**
 * IsSubscribedTFeature
 * - returns whether or not subscribed, subscription status, and subscription token
 * - if not subscribed, subscription_status and subscription_token will be empty
 *
 * SOURCE IsSubscribedToFeatureResponse @ squareup/sub2/subscription_service.proto at 418:1
 */
export const IsSubscribedToFeatureResponse = $root.lookupType('squareup.sub2.service.IsSubscribedToFeatureResponse');
fixType(IsSubscribedToFeatureResponse, {
  isSubscribed: {
    required: true
  }
});
Builder.createAndAttachToType(IsSubscribedToFeatureResponse);
/**
 * ListSubscribedFeatures
 *   - returns the list of features the subscriber is subscribed to via active/free trial subscriptions, including
 *     pending cancellation and pending pause subscriptions
 *   - if subscriber does not exist, returns an empty list.
 *
 * SOURCE ListSubscribedFeaturesRequest @ squareup/sub2/subscription_service.proto at 435:1
 */
export const ListSubscribedFeaturesRequest = $root.lookupType('squareup.sub2.service.ListSubscribedFeaturesRequest');
fixType(ListSubscribedFeaturesRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ListSubscribedFeaturesRequest);
/**
 * SOURCE ListSubscribedFeaturesResponse @ squareup/sub2/subscription_service.proto at 440:1
 */
export const ListSubscribedFeaturesResponse = $root.lookupType('squareup.sub2.service.ListSubscribedFeaturesResponse');
fixType(ListSubscribedFeaturesResponse);
Builder.createAndAttachToType(ListSubscribedFeaturesResponse);
/**
 * GetSubscription
 *   - fetches a subscription from subscription token or for the given subscriber and plan
 *   - if the subscription does not exist, returns a 404.
 *   - If the subscription_token is the empty string, returns a 400
 *   - If subscription_token is provided it will be used instead of the subscriber and plan_token
 *
 * SOURCE GetSubscriptionRequest @ squareup/sub2/subscription_service.proto at 452:1
 */
export const GetSubscriptionRequest = $root.lookupType('squareup.sub2.service.GetSubscriptionRequest');
fixType(GetSubscriptionRequest);
Builder.createAndAttachToType(GetSubscriptionRequest);
/**
 * SOURCE GetSubscriptionResponse @ squareup/sub2/subscription_service.proto at 462:1
 */
export const GetSubscriptionResponse = $root.lookupType('squareup.sub2.service.GetSubscriptionResponse');
fixType(GetSubscriptionResponse);
Builder.createAndAttachToType(GetSubscriptionResponse);
/**
 * GetPlanComponents is used specifically in Dashboard for the product retention and returns which of the given plan's
 * features that the subscriber will lose access to by unsubscribing, along with any canonical plans for those features
 *   - if there is no plan for the given plan token, responds with 404 Not Found.
 *   - does not include components that the subscriber already has access to via another plan.
 *
 * SOURCE GetPlanComponentsRequest @ squareup/sub2/subscription_service.proto at 473:1
 */
export const GetPlanComponentsRequest = $root.lookupType('squareup.sub2.service.GetPlanComponentsRequest');
fixType(GetPlanComponentsRequest, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetPlanComponentsRequest);
/**
 * SOURCE GetPlanComponentsResponse @ squareup/sub2/subscription_service.proto at 487:1
 */
export const GetPlanComponentsResponse = $root.lookupType('squareup.sub2.service.GetPlanComponentsResponse');
fixType(GetPlanComponentsResponse);
Builder.createAndAttachToType(GetPlanComponentsResponse);
/**
 * GetBillerLocationToken
 *   - returns the location token for a given countrycode
 *   - falls back to the US location token if the given countrycode is not found
 *
 * SOURCE GetBillerLocationTokenRequest @ squareup/sub2/subscription_service.proto at 498:1
 */
export const GetBillerLocationTokenRequest = $root.lookupType('squareup.sub2.service.GetBillerLocationTokenRequest');
fixType(GetBillerLocationTokenRequest, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillerLocationTokenRequest);
/**
 * SOURCE GetBillerLocationTokenResponse @ squareup/sub2/subscription_service.proto at 503:1
 */
export const GetBillerLocationTokenResponse = $root.lookupType('squareup.sub2.service.GetBillerLocationTokenResponse');
fixType(GetBillerLocationTokenResponse, {
  locationToken: {
    required: true
  },
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillerLocationTokenResponse);
/**
 * GetPricingInfoRequest
 *   - if there is no subscription for the given subscriber and plan, returns the default
 *     pricing and free trial days for the plan.
 *   - if there is a subscription:
 *       - returns the subscription's pricing (regardless of subscription state)
 *       - returns the free trial days remaining on the subscription. If the subscription is
 *         active, canceled, or delinquent, free trial days remaining will be 0. If the subscription
 *         is pending or in free trial, it will return the free trial days left.
 *   - if there is no plan for the given plan token, responds with 404 Not Found.
 *
 * SOURCE GetPricingInfoRequest @ squareup/sub2/subscription_service.proto at 522:1
 */
export const GetPricingInfoRequest = $root.lookupType('squareup.sub2.service.GetPricingInfoRequest');
fixType(GetPricingInfoRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(GetPricingInfoRequest);
/**
 * SOURCE GetPricingInfoResponse @ squareup/sub2/subscription_service.proto at 560:1
 */
export const GetPricingInfoResponse = $root.lookupType('squareup.sub2.service.GetPricingInfoResponse');
fixType(GetPricingInfoResponse, {
  pricing: {
    required: true
  },
  renewalCycle: {
    required: true
  }
});
Builder.createAndAttachToType(GetPricingInfoResponse);
/**
 * GetDefaultPricingInfoRequest
 *   - returns the default pricing for the plan, regardless of if the user is subscribed to the plan.
 *   - if there is no plan for the given plan token, responds with 404 Not Found.
 *
 * SOURCE GetDefaultPricingInfoRequest @ squareup/sub2/subscription_service.proto at 614:1
 */
export const GetDefaultPricingInfoRequest = $root.lookupType('squareup.sub2.service.GetDefaultPricingInfoRequest');
fixType(GetDefaultPricingInfoRequest, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetDefaultPricingInfoRequest);
/**
 * SOURCE GetDefaultPricingInfoResponse @ squareup/sub2/subscription_service.proto at 636:1
 */
export const GetDefaultPricingInfoResponse = $root.lookupType('squareup.sub2.service.GetDefaultPricingInfoResponse');
fixType(GetDefaultPricingInfoResponse, {
  pricing: {
    required: true
  }
});
Builder.createAndAttachToType(GetDefaultPricingInfoResponse);
/**
 * UpdateUsage
 *   - returns nothing upon success.
 *   - returns 400 if duration.inclusive_start is not present or if duration.inclusive_start
 *     is equal to or before duration.exclusive_end.
 *   - returns 404 if there is an issue finding the subscriber.
 *
 * SOURCE UpdateUsageRequest @ squareup/sub2/subscription_service.proto at 653:1
 */
export const UpdateUsageRequest = $root.lookupType('squareup.sub2.service.UpdateUsageRequest');
fixType(UpdateUsageRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateUsageRequest);
/**
 * SOURCE UpdateUsageResponse @ squareup/sub2/subscription_service.proto at 690:1
 */
export const UpdateUsageResponse = $root.lookupType('squareup.sub2.service.UpdateUsageResponse');
fixType(UpdateUsageResponse);
Builder.createAndAttachToType(UpdateUsageResponse);
/**
 * ListSubscriptions
 *   - returns subscriptions upon success.
 *   - returns an empty list if the subscriber cannot be found.
 *
 * SOURCE ListSubscriptionsRequest @ squareup/sub2/subscription_service.proto at 698:1
 */
export const ListSubscriptionsRequest = $root.lookupType('squareup.sub2.service.ListSubscriptionsRequest');
fixType(ListSubscriptionsRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ListSubscriptionsRequest);
/**
 * SOURCE ListSubscriptionsResponse @ squareup/sub2/subscription_service.proto at 707:1
 */
export const ListSubscriptionsResponse = $root.lookupType('squareup.sub2.service.ListSubscriptionsResponse');
fixType(ListSubscriptionsResponse);
Builder.createAndAttachToType(ListSubscriptionsResponse);
/**
 * ListMergedSubscriptions
 *   - returns subscriptions which hide overlapping subscriptions upon success.
 *   - returns an empty list if the subscriber cannot be found.
 *
 * SOURCE ListMergedSubscriptionsRequest @ squareup/sub2/subscription_service.proto at 720:1
 */
export const ListMergedSubscriptionsRequest = $root.lookupType('squareup.sub2.service.ListMergedSubscriptionsRequest');
fixType(ListMergedSubscriptionsRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ListMergedSubscriptionsRequest);
/**
 * SOURCE ListMergedSubscriptionsResponse @ squareup/sub2/subscription_service.proto at 725:1
 */
export const ListMergedSubscriptionsResponse = $root.lookupType('squareup.sub2.service.ListMergedSubscriptionsResponse');
fixType(ListMergedSubscriptionsResponse);
Builder.createAndAttachToType(ListMergedSubscriptionsResponse);
/**
 * SOURCE ListSubscriptionHistoryRequest @ squareup/sub2/subscription_service.proto at 733:1
 */
export const ListSubscriptionHistoryRequest = $root.lookupType('squareup.sub2.service.ListSubscriptionHistoryRequest');
fixType(ListSubscriptionHistoryRequest, {
  subscriptionToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListSubscriptionHistoryRequest);
/**
 * Subscription history events are returned by the ListSubscriptionHistory rpc in reverse chronological order.
 *
 * SOURCE ListSubscriptionHistoryResponse @ squareup/sub2/subscription_service.proto at 738:1
 */
export const ListSubscriptionHistoryResponse = $root.lookupType('squareup.sub2.service.ListSubscriptionHistoryResponse');
fixType(ListSubscriptionHistoryResponse, {
  events: {
    required: true
  }
});
Builder.createAndAttachToType(ListSubscriptionHistoryResponse);
/**
 * SubscriptionsForPayment
 *   - returns subscriptions upon success (should only be one at most)
 *   - returns an empty list if there are no charges for that payment token
 *
 * SOURCE SubscriptionsForPaymentRequest @ squareup/sub2/subscription_service.proto at 747:1
 */
export const SubscriptionsForPaymentRequest = $root.lookupType('squareup.sub2.service.SubscriptionsForPaymentRequest');
fixType(SubscriptionsForPaymentRequest, {
  paymentToken: {
    required: true
  }
});
Builder.createAndAttachToType(SubscriptionsForPaymentRequest);
/**
 * SOURCE SubscriptionsForPaymentResponse @ squareup/sub2/subscription_service.proto at 751:1
 */
export const SubscriptionsForPaymentResponse = $root.lookupType('squareup.sub2.service.SubscriptionsForPaymentResponse');
fixType(SubscriptionsForPaymentResponse);
Builder.createAndAttachToType(SubscriptionsForPaymentResponse);
/**
 * ExtendFreeTrialForSubscription
 *   - Returns a subscription with the free trial extended by the given num_days
 *   - subscription should be in free trial state.
 *   - if subscription does not exist, responds with status 404 Not Found.
 *   - if subscription is not in free trial, responds with status 400 Bad Request.
 *
 * SOURCE ExtendFreeTrialForSubscriptionRequest @ squareup/sub2/subscription_service.proto at 762:1
 */
export const ExtendFreeTrialForSubscriptionRequest = $root.lookupType('squareup.sub2.service.ExtendFreeTrialForSubscriptionRequest');
fixType(ExtendFreeTrialForSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  numDays: {
    required: true
  }
});
Builder.createAndAttachToType(ExtendFreeTrialForSubscriptionRequest);
/**
 * SOURCE ExtendFreeTrialForSubscriptionResponse @ squareup/sub2/subscription_service.proto at 787:1
 */
export const ExtendFreeTrialForSubscriptionResponse = $root.lookupType('squareup.sub2.service.ExtendFreeTrialForSubscriptionResponse');
fixType(ExtendFreeTrialForSubscriptionResponse);
Builder.createAndAttachToType(ExtendFreeTrialForSubscriptionResponse);
/**
 * UpdateFreeTrialDurationForSubscription
 *   - Returns a subscription with the free trial extended or shortened by the given num_days
 *   - subscription should be in free trial state.
 *   - if subscription does not exist, responds with status 404 Not Found.
 *   - if subscription is not in free trial, responds with status 400 Bad Request.
 *
 * SOURCE UpdateFreeTrialDurationForSubscriptionRequest @ squareup/sub2/subscription_service.proto at 799:1
 */
export const UpdateFreeTrialDurationForSubscriptionRequest = $root.lookupType('squareup.sub2.service.UpdateFreeTrialDurationForSubscriptionRequest');
fixType(UpdateFreeTrialDurationForSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  numDays: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateFreeTrialDurationForSubscriptionRequest);
/**
 * SOURCE UpdateFreeTrialDurationForSubscriptionResponse @ squareup/sub2/subscription_service.proto at 824:1
 */
export const UpdateFreeTrialDurationForSubscriptionResponse = $root.lookupType('squareup.sub2.service.UpdateFreeTrialDurationForSubscriptionResponse');
fixType(UpdateFreeTrialDurationForSubscriptionResponse);
Builder.createAndAttachToType(UpdateFreeTrialDurationForSubscriptionResponse);
/**
 * ListFeatureStatuses
 *   - Returns a list of features that the subscriber is subscribed to (or was once subscribed to) along with
 *     their current status. If a feature doesn't exist, then that feature was never subscribed.
 *   - If 2 or more subscriptions are associated with the same feature, then the token of the subscribed
 *     subscription is returned or else one of the not subscribed ones.
 *   - Returns an empty response if the subscriber doesn't exist.
 *
 * SOURCE ListFeatureStatusesRequest @ squareup/sub2/subscription_service.proto at 837:1
 */
export const ListFeatureStatusesRequest = $root.lookupType('squareup.sub2.service.ListFeatureStatusesRequest');
fixType(ListFeatureStatusesRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ListFeatureStatusesRequest);
/**
 * SOURCE ListFeatureStatusesResponse @ squareup/sub2/subscription_service.proto at 845:1
 */
export const ListFeatureStatusesResponse = $root.lookupType('squareup.sub2.service.ListFeatureStatusesResponse');
fixType(ListFeatureStatusesResponse);
Builder.createAndAttachToType(ListFeatureStatusesResponse);
/**
 * SOURCE FeatureStatus @ squareup/sub2/subscription_service.proto at 846:3
 */
ListFeatureStatusesResponse.FeatureStatus = $root.lookupType('squareup.sub2.service.ListFeatureStatusesResponse.FeatureStatus');
fixType(ListFeatureStatusesResponse.FeatureStatus, {
  feature: {
    required: true
  },
  status: {
    required: true
  },
  subscriptionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListFeatureStatusesResponse.FeatureStatus);
/**
 * ListActivePlans
 *   - Returns a list of active plan given a country code and (optionally) billing cycle.
 *   - Only returns plans with a token in the plan_tokens array if populated
 *
 * SOURCE ListActivePlansRequest @ squareup/sub2/subscription_service.proto at 865:1
 */
export const ListActivePlansRequest = $root.lookupType('squareup.sub2.service.ListActivePlansRequest');
fixType(ListActivePlansRequest, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(ListActivePlansRequest);
/**
 * SOURCE ListActivePlansResponse @ squareup/sub2/subscription_service.proto at 874:1
 */
export const ListActivePlansResponse = $root.lookupType('squareup.sub2.service.ListActivePlansResponse');
fixType(ListActivePlansResponse);
Builder.createAndAttachToType(ListActivePlansResponse);
/**
 * ListAvailablePlans
 *   - Returns a list of plans and external plans that the subscriber can subscribe to that aren't
 *     already associated with any subscriptions the subscriber already has.
 *   - Returns a 404 if the subscriber doesn't exist.
 *
 * SOURCE ListAvailablePlansRequest @ squareup/sub2/subscription_service.proto at 886:1
 */
export const ListAvailablePlansRequest = $root.lookupType('squareup.sub2.service.ListAvailablePlansRequest');
fixType(ListAvailablePlansRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(ListAvailablePlansRequest);
/**
 * SOURCE ListAvailablePlansResponse @ squareup/sub2/subscription_service.proto at 890:1
 */
export const ListAvailablePlansResponse = $root.lookupType('squareup.sub2.service.ListAvailablePlansResponse');
fixType(ListAvailablePlansResponse);
Builder.createAndAttachToType(ListAvailablePlansResponse);
/**
 * ListAvailableBundleOfferings
 *   - Returns a list of bundle offerings that the subscriber can subscribe to in accordance to their country code.
 *   - Returns a 404 if the subscriber doesn't exist.
 *
 * SOURCE ListAvailableBundleOfferingsRequest @ squareup/sub2/subscription_service.proto at 901:1
 */
export const ListAvailableBundleOfferingsRequest = $root.lookupType('squareup.sub2.service.ListAvailableBundleOfferingsRequest');
fixType(ListAvailableBundleOfferingsRequest);
Builder.createAndAttachToType(ListAvailableBundleOfferingsRequest);
/**
 * SOURCE ListAvailableBundleOfferingsResponse @ squareup/sub2/subscription_service.proto at 905:1
 */
export const ListAvailableBundleOfferingsResponse = $root.lookupType('squareup.sub2.service.ListAvailableBundleOfferingsResponse');
fixType(ListAvailableBundleOfferingsResponse);
Builder.createAndAttachToType(ListAvailableBundleOfferingsResponse);
/**
 * CreateBundleRequest
 *   - Returns the bundle created for the seller.
 *
 * SOURCE CreateBundleRequest @ squareup/sub2/subscription_service.proto at 913:1
 */
export const CreateBundleRequest = $root.lookupType('squareup.sub2.service.CreateBundleRequest');
fixType(CreateBundleRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  bundleOfferingToken: {
    required: true
  }
});
Builder.createAndAttachToType(CreateBundleRequest);
/**
 * SOURCE CreateBundleResponse @ squareup/sub2/subscription_service.proto at 931:1
 */
export const CreateBundleResponse = $root.lookupType('squareup.sub2.service.CreateBundleResponse');
fixType(CreateBundleResponse, {
  bundle: {
    required: true
  }
});
Builder.createAndAttachToType(CreateBundleResponse);
/**
 * CancelBundleRequest
 *   - Returns the bundle canceled for the seller.
 *
 * SOURCE CancelBundleRequest @ squareup/sub2/subscription_service.proto at 940:1
 */
export const CancelBundleRequest = $root.lookupType('squareup.sub2.service.CancelBundleRequest');
fixType(CancelBundleRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  bundleToken: {
    required: true
  }
});
Builder.createAndAttachToType(CancelBundleRequest);
/**
 * SOURCE CancelBundleResponse @ squareup/sub2/subscription_service.proto at 958:1
 */
export const CancelBundleResponse = $root.lookupType('squareup.sub2.service.CancelBundleResponse');
fixType(CancelBundleResponse, {
  bundle: {
    required: true
  }
});
Builder.createAndAttachToType(CancelBundleResponse);
/**
 * GetBundle
 *   - fetches a bundle from bundle token
 *   - if the bundle does not exist, returns a 404.
 *   - If the bundle_token is the empty string, returns a 400
 *
 * SOURCE GetBundleRequest @ squareup/sub2/subscription_service.proto at 969:1
 */
export const GetBundleRequest = $root.lookupType('squareup.sub2.service.GetBundleRequest');
fixType(GetBundleRequest);
Builder.createAndAttachToType(GetBundleRequest);
/**
 * SOURCE GetBundleResponse @ squareup/sub2/subscription_service.proto at 973:1
 */
export const GetBundleResponse = $root.lookupType('squareup.sub2.service.GetBundleResponse');
fixType(GetBundleResponse);
Builder.createAndAttachToType(GetBundleResponse);
/**
 * BatchCreateAndCancel
 *   - Returns a list of subscriptions that have been either created or canceled.
 *
 * SOURCE BatchCreateAndCancelSubscriptionsRequest @ squareup/sub2/subscription_service.proto at 982:1
 */
export const BatchCreateAndCancelSubscriptionsRequest = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest');
fixType(BatchCreateAndCancelSubscriptionsRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsRequest);
/**
 * SOURCE CreateSubscription @ squareup/sub2/subscription_service.proto at 983:3
 */
BatchCreateAndCancelSubscriptionsRequest.CreateSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CreateSubscription');
fixType(BatchCreateAndCancelSubscriptionsRequest.CreateSubscription, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsRequest.CreateSubscription);
/**
 * SOURCE CancelSubscription @ squareup/sub2/subscription_service.proto at 1016:3
 */
BatchCreateAndCancelSubscriptionsRequest.CancelSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CancelSubscription');
fixType(BatchCreateAndCancelSubscriptionsRequest.CancelSubscription, {
  subscriptionToken: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsRequest.CancelSubscription);
/**
 * SOURCE UpdateSubscription @ squareup/sub2/subscription_service.proto at 1031:3
 */
BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription');
fixType(BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription, {
  subscription: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription);
/**
 * SOURCE BatchCreateAndCancelSubscriptionsResponse @ squareup/sub2/subscription_service.proto at 1065:1
 */
export const BatchCreateAndCancelSubscriptionsResponse = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse');
fixType(BatchCreateAndCancelSubscriptionsResponse);
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsResponse);
/**
 * SOURCE CreatedSubscription @ squareup/sub2/subscription_service.proto at 1066:3
 */
BatchCreateAndCancelSubscriptionsResponse.CreatedSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.CreatedSubscription');
fixType(BatchCreateAndCancelSubscriptionsResponse.CreatedSubscription, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsResponse.CreatedSubscription);
/**
 * SOURCE CanceledSubscription @ squareup/sub2/subscription_service.proto at 1070:3
 */
BatchCreateAndCancelSubscriptionsResponse.CanceledSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.CanceledSubscription');
fixType(BatchCreateAndCancelSubscriptionsResponse.CanceledSubscription, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsResponse.CanceledSubscription);
/**
 * SOURCE UpdatedSubscription @ squareup/sub2/subscription_service.proto at 1074:3
 */
BatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription = $root.lookupType('squareup.sub2.service.BatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription');
fixType(BatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(BatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription);
/**
 * Create multiple brand new subscriptions non-transactionally.
 *
 * SOURCE BulkCreateSubscriptionsRequest @ squareup/sub2/subscription_service.proto at 1087:1
 */
export const BulkCreateSubscriptionsRequest = $root.lookupType('squareup.sub2.service.BulkCreateSubscriptionsRequest');
fixType(BulkCreateSubscriptionsRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  actor: {
    required: true
  },
  reason: {
    required: true
  }
});
Builder.createAndAttachToType(BulkCreateSubscriptionsRequest);
/**
 * Instead of reusing squareup.sub2.common.SubscriptionStatus directly,
 * we want to limit the options upfront to avoid confusions.
 *
 * SOURCE StartingStatus @ squareup/sub2/subscription_service.proto at 1092:3
 */
BulkCreateSubscriptionsRequest.StartingStatus = $root.lookupEnum('squareup.sub2.service.BulkCreateSubscriptionsRequest.StartingStatus').values;
/**
 * SOURCE CreateSubscriptionParams @ squareup/sub2/subscription_service.proto at 1108:3
 */
BulkCreateSubscriptionsRequest.CreateSubscriptionParams = $root.lookupType('squareup.sub2.service.BulkCreateSubscriptionsRequest.CreateSubscriptionParams');
fixType(BulkCreateSubscriptionsRequest.CreateSubscriptionParams, {
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(BulkCreateSubscriptionsRequest.CreateSubscriptionParams);
/**
 * SOURCE BulkCreateSubscriptionsResponse @ squareup/sub2/subscription_service.proto at 1162:1
 */
export const BulkCreateSubscriptionsResponse = $root.lookupType('squareup.sub2.service.BulkCreateSubscriptionsResponse');
fixType(BulkCreateSubscriptionsResponse);
Builder.createAndAttachToType(BulkCreateSubscriptionsResponse);
/**
 * SOURCE CreatedSubscription @ squareup/sub2/subscription_service.proto at 1163:3
 */
BulkCreateSubscriptionsResponse.CreatedSubscription = $root.lookupType('squareup.sub2.service.BulkCreateSubscriptionsResponse.CreatedSubscription');
fixType(BulkCreateSubscriptionsResponse.CreatedSubscription, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(BulkCreateSubscriptionsResponse.CreatedSubscription);
/**
 * SOURCE ListSubscribersRequest @ squareup/sub2/subscription_service.proto at 1180:1
 */
export const ListSubscribersRequest = $root.lookupType('squareup.sub2.service.ListSubscribersRequest');
fixType(ListSubscribersRequest, {
  feature: {
    required: true
  }
});
Builder.createAndAttachToType(ListSubscribersRequest);
/**
 * SOURCE ListSubscribersResponse @ squareup/sub2/subscription_service.proto at 1188:1
 */
export const ListSubscribersResponse = $root.lookupType('squareup.sub2.service.ListSubscribersResponse');
fixType(ListSubscribersResponse);
Builder.createAndAttachToType(ListSubscribersResponse);
/**
 * Sets the number of free trial days available for a subscriber and plan.  Does not require
 * a subscription, and does not impact active subscriptions.
 *
 * SOURCE SetAvailableFreeTrialRequest @ squareup/sub2/subscription_service.proto at 1200:1
 */
export const SetAvailableFreeTrialRequest = $root.lookupType('squareup.sub2.service.SetAvailableFreeTrialRequest');
fixType(SetAvailableFreeTrialRequest, {
  subscriptionKey: {
    required: true
  },
  remainingDuration: {
    required: true
  }
});
Builder.createAndAttachToType(SetAvailableFreeTrialRequest);
/**
 * SOURCE SetAvailableFreeTrialResponse @ squareup/sub2/subscription_service.proto at 1207:1
 */
export const SetAvailableFreeTrialResponse = $root.lookupType('squareup.sub2.service.SetAvailableFreeTrialResponse');
fixType(SetAvailableFreeTrialResponse);
Builder.createAndAttachToType(SetAvailableFreeTrialResponse);
/**
 * Sets the number of free trial days available for a subscriber and plan group tier.  Does not require
 * a subscription, and does not impact active subscriptions.
 *
 * SOURCE SetTierAvailableFreeTrialRequest @ squareup/sub2/subscription_service.proto at 1214:1
 */
export const SetTierAvailableFreeTrialRequest = $root.lookupType('squareup.sub2.service.SetTierAvailableFreeTrialRequest');
fixType(SetTierAvailableFreeTrialRequest, {
  subscriber: {
    required: true
  },
  planGroupToken: {
    notEmpty: true
  },
  tierToken: {
    notEmpty: true
  },
  billingCycle: {
    required: true
  },
  remainingDuration: {
    required: true
  }
});
Builder.createAndAttachToType(SetTierAvailableFreeTrialRequest);
/**
 * SOURCE SetTierAvailableFreeTrialResponse @ squareup/sub2/subscription_service.proto at 1231:1
 */
export const SetTierAvailableFreeTrialResponse = $root.lookupType('squareup.sub2.service.SetTierAvailableFreeTrialResponse');
fixType(SetTierAvailableFreeTrialResponse);
Builder.createAndAttachToType(SetTierAvailableFreeTrialResponse);
/**
 * SOURCE GetUiAssetsRequest @ squareup/sub2/subscription_service.proto at 1234:1
 */
export const GetUiAssetsRequest = $root.lookupType('squareup.sub2.service.GetUiAssetsRequest');
fixType(GetUiAssetsRequest, {
  planGroupToken: {
    required: true
  },
  locale: {
    required: true
  },
  ui: {
    required: true
  }
});
Builder.createAndAttachToType(GetUiAssetsRequest);
/**
 * The client UI to get assets for.
 *
 * SOURCE Ui @ squareup/sub2/subscription_service.proto at 1238:3
 */
GetUiAssetsRequest.Ui = $root.lookupEnum('squareup.sub2.service.GetUiAssetsRequest.Ui').values;
/**
 * SOURCE GetUiAssetsResponse @ squareup/sub2/subscription_service.proto at 1263:1
 */
export const GetUiAssetsResponse = $root.lookupType('squareup.sub2.service.GetUiAssetsResponse');
fixType(GetUiAssetsResponse);
Builder.createAndAttachToType(GetUiAssetsResponse);
/**
 * SOURCE GetPlanGroupRequest @ squareup/sub2/subscription_service.proto at 1314:1
 */
export const GetPlanGroupRequest = $root.lookupType('squareup.sub2.service.GetPlanGroupRequest');
fixType(GetPlanGroupRequest, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(GetPlanGroupRequest);
/**
 * SOURCE GetPlanGroupResponse @ squareup/sub2/subscription_service.proto at 1331:1
 */
export const GetPlanGroupResponse = $root.lookupType('squareup.sub2.service.GetPlanGroupResponse');
fixType(GetPlanGroupResponse);
Builder.createAndAttachToType(GetPlanGroupResponse);
/**
 * This endpoint will be called in Dashboard to show a list of features lost, maintained, or gained by a plan change,
 * as defined by the set of features on a plan but also taking into account the features that the subscriber has through
 *  other plans.This endpoint supports bulk requests but does not diff across PlanChanges
 * - The response from this endpoint does not correspond directly to sub2.data.Features but can be considered more as
 *   lists of seller-facing feature "descriptions" as determined by Content teams
 *
 * SOURCE BulkGetFeatureDiffRequest @ squareup/sub2/subscription_service.proto at 1341:1
 */
export const BulkGetFeatureDiffRequest = $root.lookupType('squareup.sub2.service.BulkGetFeatureDiffRequest');
fixType(BulkGetFeatureDiffRequest);
Builder.createAndAttachToType(BulkGetFeatureDiffRequest);
/**
 * SOURCE PlanChange @ squareup/sub2/subscription_service.proto at 1344:3
 */
BulkGetFeatureDiffRequest.PlanChange = $root.lookupType('squareup.sub2.service.BulkGetFeatureDiffRequest.PlanChange');
fixType(BulkGetFeatureDiffRequest.PlanChange);
Builder.createAndAttachToType(BulkGetFeatureDiffRequest.PlanChange);
/**
 * SOURCE BulkGetFeatureDiffResponse @ squareup/sub2/subscription_service.proto at 1363:1
 */
export const BulkGetFeatureDiffResponse = $root.lookupType('squareup.sub2.service.BulkGetFeatureDiffResponse');
fixType(BulkGetFeatureDiffResponse);
Builder.createAndAttachToType(BulkGetFeatureDiffResponse);
/**
 * SOURCE FeatureDiff @ squareup/sub2/subscription_service.proto at 1364:3
 */
BulkGetFeatureDiffResponse.FeatureDiff = $root.lookupType('squareup.sub2.service.BulkGetFeatureDiffResponse.FeatureDiff');
fixType(BulkGetFeatureDiffResponse.FeatureDiff, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(BulkGetFeatureDiffResponse.FeatureDiff);
/**
 * SOURCE CreateFeedbackOptionRequest @ squareup/sub2/subscription_service.proto at 1383:1
 */
export const CreateFeedbackOptionRequest = $root.lookupType('squareup.sub2.service.CreateFeedbackOptionRequest');
fixType(CreateFeedbackOptionRequest, {
  token: {
    notEmpty: true
  },
  inputType: {
    required: true
  }
});
Builder.createAndAttachToType(CreateFeedbackOptionRequest);
/**
 * SOURCE CreateFeedbackOptionResponse @ squareup/sub2/subscription_service.proto at 1394:1
 */
export const CreateFeedbackOptionResponse = $root.lookupType('squareup.sub2.service.CreateFeedbackOptionResponse');
fixType(CreateFeedbackOptionResponse);
Builder.createAndAttachToType(CreateFeedbackOptionResponse);
/**
 * SOURCE RetrieveFeedbackOptionRequest @ squareup/sub2/subscription_service.proto at 1398:1
 */
export const RetrieveFeedbackOptionRequest = $root.lookupType('squareup.sub2.service.RetrieveFeedbackOptionRequest');
fixType(RetrieveFeedbackOptionRequest, {
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveFeedbackOptionRequest);
/**
 * SOURCE RetrieveFeedbackOptionResponse @ squareup/sub2/subscription_service.proto at 1402:1
 */
export const RetrieveFeedbackOptionResponse = $root.lookupType('squareup.sub2.service.RetrieveFeedbackOptionResponse');
fixType(RetrieveFeedbackOptionResponse);
Builder.createAndAttachToType(RetrieveFeedbackOptionResponse);
/**
 * SOURCE CreateFeedbackOptionListRequest @ squareup/sub2/subscription_service.proto at 1406:1
 */
export const CreateFeedbackOptionListRequest = $root.lookupType('squareup.sub2.service.CreateFeedbackOptionListRequest');
fixType(CreateFeedbackOptionListRequest, {
  token: {
    notEmpty: true
  },
  feedbackOptionTokens: {
    required: true
  }
});
Builder.createAndAttachToType(CreateFeedbackOptionListRequest);
/**
 * SOURCE CreateFeedbackOptionListResponse @ squareup/sub2/subscription_service.proto at 1410:1
 */
export const CreateFeedbackOptionListResponse = $root.lookupType('squareup.sub2.service.CreateFeedbackOptionListResponse');
fixType(CreateFeedbackOptionListResponse);
Builder.createAndAttachToType(CreateFeedbackOptionListResponse);
/**
 * SOURCE RetrieveFeedbackOptionListRequest @ squareup/sub2/subscription_service.proto at 1414:1
 */
export const RetrieveFeedbackOptionListRequest = $root.lookupType('squareup.sub2.service.RetrieveFeedbackOptionListRequest');
fixType(RetrieveFeedbackOptionListRequest, {
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveFeedbackOptionListRequest);
/**
 * SOURCE RetrieveFeedbackOptionListResponse @ squareup/sub2/subscription_service.proto at 1418:1
 */
export const RetrieveFeedbackOptionListResponse = $root.lookupType('squareup.sub2.service.RetrieveFeedbackOptionListResponse');
fixType(RetrieveFeedbackOptionListResponse);
Builder.createAndAttachToType(RetrieveFeedbackOptionListResponse);
/**
 * SOURCE UpdateFeedbackOptionListRequest @ squareup/sub2/subscription_service.proto at 1422:1
 */
export const UpdateFeedbackOptionListRequest = $root.lookupType('squareup.sub2.service.UpdateFeedbackOptionListRequest');
fixType(UpdateFeedbackOptionListRequest, {
  token: {
    notEmpty: true
  },
  feedbackOptionTokens: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateFeedbackOptionListRequest);
/**
 * SOURCE UpdateFeedbackOptionListResponse @ squareup/sub2/subscription_service.proto at 1427:1
 */
export const UpdateFeedbackOptionListResponse = $root.lookupType('squareup.sub2.service.UpdateFeedbackOptionListResponse');
fixType(UpdateFeedbackOptionListResponse);
Builder.createAndAttachToType(UpdateFeedbackOptionListResponse);
/**
 * SOURCE GetFeedbackOptionListForPlanRequest @ squareup/sub2/subscription_service.proto at 1431:1
 */
export const GetFeedbackOptionListForPlanRequest = $root.lookupType('squareup.sub2.service.GetFeedbackOptionListForPlanRequest');
fixType(GetFeedbackOptionListForPlanRequest);
Builder.createAndAttachToType(GetFeedbackOptionListForPlanRequest);
/**
 * SOURCE GetFeedbackOptionListForPlanResponse @ squareup/sub2/subscription_service.proto at 1435:1
 */
export const GetFeedbackOptionListForPlanResponse = $root.lookupType('squareup.sub2.service.GetFeedbackOptionListForPlanResponse');
fixType(GetFeedbackOptionListForPlanResponse);
Builder.createAndAttachToType(GetFeedbackOptionListForPlanResponse);
/**
 * SOURCE GetFutureSubscribedFeatureDiffRequest @ squareup/sub2/subscription_service.proto at 1439:1
 */
export const GetFutureSubscribedFeatureDiffRequest = $root.lookupType('squareup.sub2.service.GetFutureSubscribedFeatureDiffRequest');
fixType(GetFutureSubscribedFeatureDiffRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(GetFutureSubscribedFeatureDiffRequest);
/**
 * SOURCE GetFutureSubscribedFeatureDiffResponse @ squareup/sub2/subscription_service.proto at 1450:1
 */
export const GetFutureSubscribedFeatureDiffResponse = $root.lookupType('squareup.sub2.service.GetFutureSubscribedFeatureDiffResponse');
fixType(GetFutureSubscribedFeatureDiffResponse);
Builder.createAndAttachToType(GetFutureSubscribedFeatureDiffResponse);
/**
 * SOURCE SyncSquareOneAvtBucketingResultRequest @ squareup/sub2/subscription_service.proto at 1459:1
 */
export const SyncSquareOneAvtBucketingResultRequest = $root.lookupType('squareup.sub2.service.SyncSquareOneAvtBucketingResultRequest');
fixType(SyncSquareOneAvtBucketingResultRequest, {
  merchantToken: {
    required: true
  },
  avt: {
    required: true
  }
});
Builder.createAndAttachToType(SyncSquareOneAvtBucketingResultRequest);
/**
 * SOURCE SyncSquareOneAvtBucketingResultResponse @ squareup/sub2/subscription_service.proto at 1478:1
 */
export const SyncSquareOneAvtBucketingResultResponse = $root.lookupType('squareup.sub2.service.SyncSquareOneAvtBucketingResultResponse');
fixType(SyncSquareOneAvtBucketingResultResponse);
Builder.createAndAttachToType(SyncSquareOneAvtBucketingResultResponse);
/**
 * SOURCE SquareOneEligibilityOverride @ squareup/sub2/subscription_service.proto at 1486:1
 */
export const SquareOneEligibilityOverride = $root.lookupType('squareup.sub2.service.SquareOneEligibilityOverride');
fixType(SquareOneEligibilityOverride, {
  isEligible: {
    required: true
  }
});
Builder.createAndAttachToType(SquareOneEligibilityOverride);
/**
 * SOURCE GetOrSetSquareOneEligibilityRequest @ squareup/sub2/subscription_service.proto at 1494:1
 */
export const GetOrSetSquareOneEligibilityRequest = $root.lookupType('squareup.sub2.service.GetOrSetSquareOneEligibilityRequest');
fixType(GetOrSetSquareOneEligibilityRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetOrSetSquareOneEligibilityRequest);
/**
 * SOURCE MigrationExperiment @ squareup/sub2/subscription_service.proto at 1511:1
 */
export const MigrationExperiment = $root.lookupType('squareup.sub2.service.MigrationExperiment');
fixType(MigrationExperiment, {
  experimentToken: {
    required: true
  },
  experimentType: {
    required: true
  },
  experimentStartDate: {
    required: true
  },
  experimentPlanToken: {
    required: true
  }
});
Builder.createAndAttachToType(MigrationExperiment);
/**
 * Whether the experiment requires opt-in or will auto-migrate at a given date.
 *
 * SOURCE ExperimentType @ squareup/sub2/subscription_service.proto at 1513:3
 */
MigrationExperiment.ExperimentType = $root.lookupEnum('squareup.sub2.service.MigrationExperiment.ExperimentType').values;
/**
 * SOURCE GetOrSetSquareOneEligibilityResponse @ squareup/sub2/subscription_service.proto at 1548:1
 */
export const GetOrSetSquareOneEligibilityResponse = $root.lookupType('squareup.sub2.service.GetOrSetSquareOneEligibilityResponse');
fixType(GetOrSetSquareOneEligibilityResponse);
Builder.createAndAttachToType(GetOrSetSquareOneEligibilityResponse);
/**
 * SOURCE GetTierRecommendationRequest @ squareup/sub2/subscription_service.proto at 1560:1
 */
export const GetTierRecommendationRequest = $root.lookupType('squareup.sub2.service.GetTierRecommendationRequest');
fixType(GetTierRecommendationRequest, {
  subscriber: {
    required: true
  },
  planGroupToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetTierRecommendationRequest);
/**
 * SOURCE GetTierRecommendationResponse @ squareup/sub2/subscription_service.proto at 1568:1
 */
export const GetTierRecommendationResponse = $root.lookupType('squareup.sub2.service.GetTierRecommendationResponse');
fixType(GetTierRecommendationResponse);
Builder.createAndAttachToType(GetTierRecommendationResponse);
/**
 * SOURCE GetSquareOneSubscriptionInfoRequest @ squareup/sub2/subscription_service.proto at 1573:1
 */
export const GetSquareOneSubscriptionInfoRequest = $root.lookupType('squareup.sub2.service.GetSquareOneSubscriptionInfoRequest');
fixType(GetSquareOneSubscriptionInfoRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetSquareOneSubscriptionInfoRequest);
/**
 * SOURCE GetSquareOneSubscriptionInfoResponse @ squareup/sub2/subscription_service.proto at 1582:1
 */
export const GetSquareOneSubscriptionInfoResponse = $root.lookupType('squareup.sub2.service.GetSquareOneSubscriptionInfoResponse');
fixType(GetSquareOneSubscriptionInfoResponse);
Builder.createAndAttachToType(GetSquareOneSubscriptionInfoResponse);
/**
 * SOURCE TrialInfo @ squareup/sub2/subscription_service.proto at 1583:3
 */
GetSquareOneSubscriptionInfoResponse.TrialInfo = $root.lookupType('squareup.sub2.service.GetSquareOneSubscriptionInfoResponse.TrialInfo');
fixType(GetSquareOneSubscriptionInfoResponse.TrialInfo);
Builder.createAndAttachToType(GetSquareOneSubscriptionInfoResponse.TrialInfo);
/**
 * The previous plan token and status of the subscription.
 * One or both of these fields differs from the subscription's current values
 *
 * SOURCE PreviousSubscriptionState @ squareup/sub2/subscription_service.proto at 1593:3
 */
GetSquareOneSubscriptionInfoResponse.PreviousSubscriptionState = $root.lookupType('squareup.sub2.service.GetSquareOneSubscriptionInfoResponse.PreviousSubscriptionState');
fixType(GetSquareOneSubscriptionInfoResponse.PreviousSubscriptionState);
Builder.createAndAttachToType(GetSquareOneSubscriptionInfoResponse.PreviousSubscriptionState);
/**
 * SOURCE CreateSquareOneSubscriptionIfEligibleRequest @ squareup/sub2/subscription_service.proto at 1617:1
 */
export const CreateSquareOneSubscriptionIfEligibleRequest = $root.lookupType('squareup.sub2.service.CreateSquareOneSubscriptionIfEligibleRequest');
fixType(CreateSquareOneSubscriptionIfEligibleRequest, {
  merchantToken: {
    required: true
  },
  idempotenceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateSquareOneSubscriptionIfEligibleRequest);
/**
 * SOURCE CreateSquareOneSubscriptionIfEligibleResponse @ squareup/sub2/subscription_service.proto at 1650:1
 */
export const CreateSquareOneSubscriptionIfEligibleResponse = $root.lookupType('squareup.sub2.service.CreateSquareOneSubscriptionIfEligibleResponse');
fixType(CreateSquareOneSubscriptionIfEligibleResponse);
Builder.createAndAttachToType(CreateSquareOneSubscriptionIfEligibleResponse);
/**
 * SOURCE ListTrialsRequest @ squareup/sub2/subscription_service.proto at 1658:1
 */
export const ListTrialsRequest = $root.lookupType('squareup.sub2.service.ListTrialsRequest');
fixType(ListTrialsRequest, {
  subscriber: {
    required: true
  },
  planGroupToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListTrialsRequest);
/**
 * SOURCE ListTrialsResponse @ squareup/sub2/subscription_service.proto at 1665:1
 */
export const ListTrialsResponse = $root.lookupType('squareup.sub2.service.ListTrialsResponse');
fixType(ListTrialsResponse);
Builder.createAndAttachToType(ListTrialsResponse);
/**
 * SOURCE ForceTransitionSubscriptionRequest @ squareup/sub2/subscription_service.proto at 1674:1
 */
export const ForceTransitionSubscriptionRequest = $root.lookupType('squareup.sub2.service.ForceTransitionSubscriptionRequest');
fixType(ForceTransitionSubscriptionRequest, {
  subscriptionToken: {
    required: true
  },
  targetStatus: {
    required: true
  }
});
Builder.createAndAttachToType(ForceTransitionSubscriptionRequest);
/**
 * SOURCE ForceTransitionSubscriptionResponse @ squareup/sub2/subscription_service.proto at 1681:1
 */
export const ForceTransitionSubscriptionResponse = $root.lookupType('squareup.sub2.service.ForceTransitionSubscriptionResponse');
fixType(ForceTransitionSubscriptionResponse);
Builder.createAndAttachToType(ForceTransitionSubscriptionResponse);
/**
 * SOURCE GetSquareOnePlansRequest @ squareup/sub2/subscription_service.proto at 1686:1
 */
export const GetSquareOnePlansRequest = $root.lookupType('squareup.sub2.service.GetSquareOnePlansRequest');
fixType(GetSquareOnePlansRequest);
Builder.createAndAttachToType(GetSquareOnePlansRequest);
/**
 * SOURCE GetSquareOnePlansResponse @ squareup/sub2/subscription_service.proto at 1689:1
 */
export const GetSquareOnePlansResponse = $root.lookupType('squareup.sub2.service.GetSquareOnePlansResponse');
fixType(GetSquareOnePlansResponse);
Builder.createAndAttachToType(GetSquareOnePlansResponse);
/**
 * SOURCE SetSquareOneMigrationDecisionRequest @ squareup/sub2/subscription_service.proto at 1697:1
 */
export const SetSquareOneMigrationDecisionRequest = $root.lookupType('squareup.sub2.service.SetSquareOneMigrationDecisionRequest');
fixType(SetSquareOneMigrationDecisionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  experimentToken: {
    required: true
  },
  newMigrationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(SetSquareOneMigrationDecisionRequest);
/**
 * SOURCE SetSquareOneMigrationDecisionResponse @ squareup/sub2/subscription_service.proto at 1711:1
 */
export const SetSquareOneMigrationDecisionResponse = $root.lookupType('squareup.sub2.service.SetSquareOneMigrationDecisionResponse');
fixType(SetSquareOneMigrationDecisionResponse, {
  experimentToken: {
    required: true
  },
  migrationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(SetSquareOneMigrationDecisionResponse);
/**
 * SOURCE CreateMigrationEnrollmentsRequest @ squareup/sub2/subscription_service.proto at 1722:1
 */
export const CreateMigrationEnrollmentsRequest = $root.lookupType('squareup.sub2.service.CreateMigrationEnrollmentsRequest');
fixType(CreateMigrationEnrollmentsRequest, {
  experimentToken: {
    required: true
  }
});
Builder.createAndAttachToType(CreateMigrationEnrollmentsRequest);
/**
 * SOURCE CreateMigrationEnrollmentsResponse @ squareup/sub2/subscription_service.proto at 1733:1
 */
export const CreateMigrationEnrollmentsResponse = $root.lookupType('squareup.sub2.service.CreateMigrationEnrollmentsResponse');
fixType(CreateMigrationEnrollmentsResponse);
Builder.createAndAttachToType(CreateMigrationEnrollmentsResponse);
/**
 * SOURCE GetSquareOneMigrationFeaturesRequest @ squareup/sub2/subscription_service.proto at 1737:1
 */
export const GetSquareOneMigrationFeaturesRequest = $root.lookupType('squareup.sub2.service.GetSquareOneMigrationFeaturesRequest');
fixType(GetSquareOneMigrationFeaturesRequest, {
  subscriber: {
    required: true
  },
  planGroupToken: {
    required: true
  },
  locale: {
    required: true
  }
});
Builder.createAndAttachToType(GetSquareOneMigrationFeaturesRequest);
/**
 * SOURCE GetSquareOneMigrationFeaturesResponse @ squareup/sub2/subscription_service.proto at 1747:1
 */
export const GetSquareOneMigrationFeaturesResponse = $root.lookupType('squareup.sub2.service.GetSquareOneMigrationFeaturesResponse');
fixType(GetSquareOneMigrationFeaturesResponse);
Builder.createAndAttachToType(GetSquareOneMigrationFeaturesResponse);
/**
 * SOURCE FeaturesByPlan @ squareup/sub2/subscription_service.proto at 1750:3
 */
GetSquareOneMigrationFeaturesResponse.FeaturesByPlan = $root.lookupType('squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.FeaturesByPlan');
fixType(GetSquareOneMigrationFeaturesResponse.FeaturesByPlan);
Builder.createAndAttachToType(GetSquareOneMigrationFeaturesResponse.FeaturesByPlan);
/**
 * SOURCE FeaturePlanEntry @ squareup/sub2/subscription_service.proto at 1760:3
 */
GetSquareOneMigrationFeaturesResponse.FeaturePlanEntry = $root.lookupType('squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.FeaturePlanEntry');
fixType(GetSquareOneMigrationFeaturesResponse.FeaturePlanEntry);
Builder.createAndAttachToType(GetSquareOneMigrationFeaturesResponse.FeaturePlanEntry);
/**
 * SOURCE EntitlementByPlan @ squareup/sub2/subscription_service.proto at 1769:3
 */
GetSquareOneMigrationFeaturesResponse.EntitlementByPlan = $root.lookupType('squareup.sub2.service.GetSquareOneMigrationFeaturesResponse.EntitlementByPlan');
fixType(GetSquareOneMigrationFeaturesResponse.EntitlementByPlan);
Builder.createAndAttachToType(GetSquareOneMigrationFeaturesResponse.EntitlementByPlan);
/**
 * SOURCE GetSquareOneLostFeaturesRequest @ squareup/sub2/subscription_service.proto at 1777:1
 */
export const GetSquareOneLostFeaturesRequest = $root.lookupType('squareup.sub2.service.GetSquareOneLostFeaturesRequest');
fixType(GetSquareOneLostFeaturesRequest, {
  subscriber: {
    required: true
  },
  planGroupToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetSquareOneLostFeaturesRequest);
/**
 * SOURCE LostFeaturesByPlan @ squareup/sub2/subscription_service.proto at 1785:1
 */
export const LostFeaturesByPlan = $root.lookupType('squareup.sub2.service.LostFeaturesByPlan');
fixType(LostFeaturesByPlan);
Builder.createAndAttachToType(LostFeaturesByPlan);
/**
 * SOURCE GetSquareOneLostFeaturesResponse @ squareup/sub2/subscription_service.proto at 1793:1
 */
export const GetSquareOneLostFeaturesResponse = $root.lookupType('squareup.sub2.service.GetSquareOneLostFeaturesResponse');
fixType(GetSquareOneLostFeaturesResponse);
Builder.createAndAttachToType(GetSquareOneLostFeaturesResponse);
/**
 * SOURCE MigrateToSquareOneRequest @ squareup/sub2/subscription_service.proto at 1798:1
 */
export const MigrateToSquareOneRequest = $root.lookupType('squareup.sub2.service.MigrateToSquareOneRequest');
fixType(MigrateToSquareOneRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  subscriber: {
    required: true
  },
  actor: {
    required: true
  },
  planToken: {
    required: true
  }
});
Builder.createAndAttachToType(MigrateToSquareOneRequest);
/**
 * SOURCE MigrateToSquareOneResponse @ squareup/sub2/subscription_service.proto at 1815:1
 */
export const MigrateToSquareOneResponse = $root.lookupType('squareup.sub2.service.MigrateToSquareOneResponse');
fixType(MigrateToSquareOneResponse, {
  migrationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(MigrateToSquareOneResponse);
/**
 * SOURCE SyncBillableLocationRequest @ squareup/sub2/subscription_service.proto at 2149:1
 */
export const SyncBillableLocationRequest = $root.lookupType('squareup.sub2.service.SyncBillableLocationRequest');
fixType(SyncBillableLocationRequest, {
  subscriber: {
    required: true
  }
});
Builder.createAndAttachToType(SyncBillableLocationRequest);
/**
 * SOURCE SyncBillableLocationResponse @ squareup/sub2/subscription_service.proto at 2154:1
 */
export const SyncBillableLocationResponse = $root.lookupType('squareup.sub2.service.SyncBillableLocationResponse');
fixType(SyncBillableLocationResponse, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(SyncBillableLocationResponse);
/**
 * SubscriptionService provides APIs to manage subscriptions for products.
 *
 * SOURCE SubscriptionService @ squareup/sub2/subscription_service.proto at 1829:1
 */
export const SubscriptionService = $root.lookupService('squareup.sub2.service.SubscriptionService');